import { NavLink } from 'react-router-dom';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';
import { useResourceStore } from '../../stores/courses';

export const ResourcesViewMemberIdUnitIdLessonIdResourceIdBreadcrumb: BreadcrumbComponentType<
	'memberId' | 'unitId' | 'lessonId' | 'resourceId'
> = ({ location }) => {
	const resource = useResourceStore((state) => state.resource);

	// Se comprueba `Resource` y no solo `resource`: cuando el endpoint responde
	// un error, la vista igual guarda `response`, que ahí solo trae `message` y
	// `redirectUrl`. El objeto existe pero está vacío de recurso, y leerle el
	// nombre tumbaba toda la vista.
	if (!resource?.Resource?.name) {
		return null;
	}

	return <NavLink to={location.pathname}>{resource.Resource.name}</NavLink>;
};
